export class RecordingAlreadyHasSttError extends Error {
  constructor() {
    super('Speech-to-text has already been requested for this recording.')
    Object.setPrototypeOf(this, RecordingAlreadyHasSttError.prototype)
  }
}
